import { IAllProposalDetails, IBudget } from '@opengov/stories-shared/types';

import { compact } from 'lodash';
import { ISelectedProposalInfo } from '../../../types';

export const getProposalDetails = (budget: IBudget | null | undefined, proposalFieldsDetails: IAllProposalDetails) => {
  if (!budget) return [];
  const { budgetId, proposals } = budget;
  const proposalDetails: ISelectedProposalInfo[] = compact(
    proposals?.map((proposal) => {
      const proposalInfo = proposalFieldsDetails[proposal.proposalId];
      if (proposalInfo) {
        return {
          proposalId: proposal.proposalId,
          budgetId,
          uuid: proposalInfo.uuid,
          title: proposalInfo.title,
          id: proposal.id,
          replacedProposal: ''
        };
      }
      return null;
    })
  );
  return proposalDetails;
};
